import { render, staticRenderFns } from "./VideoConf.vue?vue&type=template&id=fdbc0cdc&scoped=true&lang=pug&"
import script from "./VideoConf.vue?vue&type=script&lang=js&"
export * from "./VideoConf.vue?vue&type=script&lang=js&"
import style0 from "./VideoConf.vue?vue&type=style&index=0&id=fdbc0cdc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbc0cdc",
  null
  
)

export default component.exports